import React, { Component } from "react";
import SelectForm from "../../html/selectForm";
import commonContext, { AppContext } from "../../../../common/context/common";
import { leadType } from "../../../../app";

interface IProps {
    onclickhandler: Function;
    history?: any;
}
interface IState {
    nutureOfReletionSwitch: boolean;
}
export class IAgreeTerms extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;

    constructor(props: IProps) {
        super(props);
        this.state = { nutureOfReletionSwitch: false };
    }
    componentDidMount() {
        this.setLead = (this.context as AppContext).setLead;
    }
    handleOnChangeNutureOfReletionChecked = (e) => {
        this.lead = (this.context as AppContext).lead as leadType;
        if (e.target.value === "Yes") {
            this.setState({ nutureOfReletionSwitch: true });
        } else {
            this.setState({ nutureOfReletionSwitch: false });
            this.setLead({ natureOfRelation: "" });
        }
    };
    handleOnChangeNutureOfReletionInput = (e) => {
        if (this.state.nutureOfReletionSwitch) {
            this.setLead({ natureOfRelation: e.target.value });
        }
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        let hiddenClassForNutureOfReleion = "";
        hiddenClassForNutureOfReleion = this.state.nutureOfReletionSwitch
            ? ""
            : "hidden";
        return (
            <>
                <div className="container my-5 mx-auto px-2 md:px-5">
                    <h2 className="openSans-Reg text-black mt-3 my-6 md:mt-5 md:my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                        Most important terms and conditions
                    </h2>
                    <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                        I/We agree and confirm:
                        <br />
                        <br />
                        (1) To the applicable schedule of charges, fees,
                        commissions including the key facts informed to me by
                        HDFC Bank Ltd. (Bank) and as more particularly mentioned
                        in the “Schedule of Charges” of this Application.
                        <br />
                        (2) That the bank’s representative/ staff will not
                        receive any payment in cash/ bearer cheque or kind along
                        with or in connection with this loan application from
                        me/ us.
                        <br />
                        (3) That no discount or free gift or any other
                        commitment whatsoever is given to me/ us by the Bank or
                        any of its authorized representative(s) other than what
                        is not documented in this application form the Terms and
                        Conditions/ Agreement pursuant to the Loan.
                        <br />
                        (4) The Bank shall not process incomplete/ defective
                        application form, for which if any loss or delay is
                        caused to me/ us, I/We will not hold the Bank liable for
                        such loss or delay. <br />
                        (5) That Loan processing and disbursement will take at
                        least 7 working days post submission of all requisite
                        documents and information as may be required by the Bank
                        as per Bank’s criteria. <br />
                        (6) That submission of loan application to your bank
                        does not imply automatic approval by the Bank and the
                        Bank will decide the quantum of the loan at its sole and
                        absolute discretion. The Bank in its sole and absolute
                        discretion may either sanction or reject the application
                        for granting the loan. Incase of rejection, the Bank
                        shall not be required to give any reason. <br />
                        (7) That the Bank shall have the right to make
                        disclosure of any information relating to me/us
                        including personal information, details in relation to
                        Loan, defaults, security, etc to the Credit Information
                        Bureau of India (CIBIL) and/or any other
                        governmental/regulatory/statutory or private
                        agency/entity, credit bureau, RBI, the Bank’s other
                        branches/ subsidiaries / affiliates / rating agencies,
                        service providers, other banks / financial institutions,
                        any third parties, any assignes/potential assignees or
                        transferees, who may need, process and publish the
                        information in such manner and through such medium as it
                        may be deemed necessary by the publisher/ Bank/ RBI,
                        including publishing the name as part of willful
                        defaulter’s list from time to time, as also use for KYC
                        information verification, credit risk analysis, or for
                        other related purposes.
                        <br />
                        (8) The Bank reserves its right to reject the loan
                        application and retain the loan application form along
                        with the photograph, information and documents. <br />
                        (9) That I/ We shall furnish any additional documents as
                        and when required by the Bank.
                        <br />
                        (10) That I/ We have not taken any loan from any other
                        bank/ finance company unless specifically declared by
                        me/ us. <br />
                        (11) That there is no impediment or restriction (whether
                        legal or judicial) against me/ us and/or our asset
                        filed/ reported by any other bank/ financer/ bank.
                        <br />
                        (12) That the funds shall be used for the purpose for
                        which loan has been applied and will not be used for
                        speculative or antisocial purpose. <br />
                        (13) I/ We do not have any existing customer ID or
                        customer ID apart from the one mentioned above, and
                        incase found otherwise, Bank reserves the right to
                        consolidate the customer IDs under a single customer ID
                        as it may decide, without any prior notice to me/ us.{" "}
                        <br />
                        (14) That the information furnished by me/ us above is
                        true and accurate.
                        <br />
                        Other declarations: I/We : <br />
                        (1) shall advise the HDFC Bank Ltd. (Bank) in writing of
                        any change in my/ our residential or employment address.{" "}
                        <br />
                        (2) hereby authorize and give consent to the Bank to
                        disclose, without notice to me/ us, information
                        furnished by me/ us in the application form(s)/ related
                        documents executed/ to be executed in relation to the
                        facilities to be availed by me/ us from the Bank, to the
                        Bank’s other branches/ subsidiaries/ affiliates/ Credit
                        Bureaus/ Rating Agencies/ Service Providers, banks/
                        financial institutions, governmental/ regulatory
                        authorities or third parties for information
                        verification, credit risk analysis, or for other related
                        purposes that the Bank may deem fit. I/ We waive the
                        privilege of privacy and privity of contract. <br />
                        (3) shall credit all sums received by you in either or
                        all the names of this account.
                        <br />
                        (4) hereby confirm having received, read and understood
                        the terms and conditions applicable to this loan
                        including the application form and the Terms and
                        Conditions/ Agreement and accept the same.
                        <br />
                        (5) hereby unconditionally, agree that these terms may
                        be changed by the Bank at any time and I / We will be
                        bound by the amended terms and conditions. <br />
                        (6) Confirm that I/ We are citizen of India. I / We also
                        confirm that the executive collecting my loan
                        Application / Document has informed me / us : <br />
                        (1) that Govt Taxes & Levies is applicable and will be
                        charged in connection with the loan. <br />
                        (2) all the commission/s (in the form of up front and
                        trail commissions) payable to HDFC Bank for the
                        insurance policy recommended to me/us. <br />
                        (3) In the case of loan cancellation, the applicable
                        pro-rata interest charges on any outstanding loan amount
                        will have to be borne by me/us. I understand that
                        Processing Fee, Stamp Duty are non-refundable charges
                        and would not be waived/ refunded in case of loan
                        cancellation or where the loan has not been disbursed.{" "}
                        <br />
                        (4) That all the post-dated cheques are to be issued
                        favouring HDFC Bank Limited A/c only. <br />
                        (5) that loan related information like “welcome letter”,
                        “repayment schedule”, “Terms and condition”, “disbursal
                        advice (as applicable to Personal Loan/ Business Loan)”,
                        will be sent on the e-mail id mentioned by me/ us in
                        this loan application form. <br />
                        (6) that I/ We can log on to HDFC Bank Net Banking
                        (www.hdfcbank.com) to view the welcome letter and
                        repayment schedule. I/ We may also request for a
                        physical copy of Welcome Letter and Repayment Schedule
                        separately if need be.
                    </div>
                    <h2 className="openSans-Reg text-black mt-3 my-6 md:mt-5 md:my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                        Acceptance of fees and charges
                    </h2>
                    <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                        <table className="border-collapse border-black w-full">
                            <tbody>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Loan Amount{" "}
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        {this.lead.totalAmount}/-
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Tenor
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        {this.lead.liTenure} Months.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Interest Rate
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        {this.lead.interestRate} % per annum.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        EMI
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        {this.lead.emi}/-
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Processing fees + Govt Taxes &amp;
                                        Levies (non-refundable)
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        {this.lead.processingFees}/-
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Stamp duty
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        {this.lead.stampDuty}/-
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Collateral Charges
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        {this.lead.collateralCharges}/-
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        EMI return charges
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        550/- + Govt Taxes &amp; Levies per
                                        instance.{" "}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Overdue EMI Interest
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        2% per month for the overdue period on
                                        EMI.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Foreclosure Charges *
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        No foreclosure allowed within 6 months
                                        from date of availing the car loan.
                                        <br />
                                        6% of Principal Outstanding for
                                        preclosures within 1 year from 7th EMI.
                                        <br />
                                        5% of Principal Outstanding for
                                        preclosures within 13-24 months from 1st
                                        EMI.
                                        <br />
                                        3% of Principal Outstanding for
                                        preclosures post 24 months from 1st EMI.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Part Payment Charges *
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        Part-payment is allowed subject to
                                        completion of 12 months (i.e., Post
                                        payment of 12 EMIs).
                                        <br />
                                        Part payment will be allowed twice only
                                        during loan tenure. Part payment is
                                        allowed only once a year. At any point
                                        of time, part payment will not increase
                                        beyond 25% of Principal Outstanding.
                                        <br />
                                        5% on the part payment amount in case
                                        part prepayment is within 13-24 months
                                        from 1st EMI.
                                        <br />
                                        3% on the part payment amount in case
                                        part prepayment is post 24 months from
                                        1st EMI.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Loan Cancellation Charges
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        NIL
                                        <br />
                                        Interest would be charged for the
                                        interim period between date of loan to
                                        loan cancellation and Processing fees,
                                        Documentation charges &amp; Stamp Duty
                                        would be retained.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Duplicate Repayment Schedule Charges
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        200/-
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Cheque/ ECS Swapping Charges
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        500/- per Instance.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Duplicate No due certificate / NOC
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        500/- per Instance.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Commercial / Personal Use NOC
                                        <br />
                                        (conversion subject to credit approval)
                                        :
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        2250/- per NOC.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        LPG/ CNG NOC/ Other Special NOC
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        500/- per instance.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        CIBIL report copy charges
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        50/-
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-2">
                                        Date on which annual balance outstanding
                                        statement will be issued by HDFC Bank.
                                    </td>
                                    <td className="border border-black px-2 py-2">
                                        31st May every year.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>{" "}
                    <h2 className="openSans-Reg text-black mt-3 my-6 md:mt-5 md:my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                        Standing instruction for repayment of monthly instalment
                    </h2>
                    <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                        Standing Instruction for Repayment of Monthly
                        instalmentsI Agree to the Terms and the Account number
                        confirmed by me for Standing Instruction I have taken a
                        New Car Loan from HDFC Bank and would like to avail of
                        the Standing Instruction facility offered by your bank
                        to make repayments towards my loan. I, therefore,
                        request you to accept this mandate to debit my Account
                        Number 03911240015450 towards recovery of repayment dues
                        of my loan account as per due dates & terms and
                        conditions mentioned in the loan agreement schedule or
                        as per revised instructions basis requirements as
                        communicated from my end in line with the Bank’s policy.
                        I undertake to maintain sufficient balances to cover the
                        Loan Repayment Dues (and charges, if any) on the
                        stipulated due dates. I also understand that the failure
                        to repay my loan amount through this standing
                        instruction shall be treated as a default in repayment
                        of dues and all charges / penalties / levies as covered
                        by the agreement will hold good towards the non payment
                        of obligations. Please treat this as an irrevocable
                        communication as an authorization to debit my account
                        every month with the required amounts towards the
                        repayment of my loan. In the event of the above account
                        getting closed/transferred for any reason, I / We will
                        intimate to the Bank the new account opened with the
                        bank to debit the Loan Repayment amounts as per the
                        agreement. Further, I /We undertake the responsibility
                        to provide the fresh set of Mandate and security PDCs
                        for such new account, as per terms of the agreement in
                        lieu of existing instructions. I also understand and
                        accept that the Bank will have the right to set-off,
                        without prior intimation to me, the available balances
                        in the designated account for recovery of overdue
                        installments and/or charges (if I also understand and
                        accept that the Bank will have the right to set-off,
                        without prior intimation to me, the available balances
                        in the designated account for recovery of overdue
                        installments and/or charges (if any) in the loan
                        account.SubmitView and execute the loan agreement by
                        using OTP
                    </div>
                    <h2 className="openSans-Reg text-black mt-3 my-6 md:mt-5 md:my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                        Relationship with directors of banks
                    </h2>
                    <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-8">
                        Are you a director of any Bank other than HDFC Bank?{" "}
                        <strong>or</strong>
                        <br />
                        Are you a relative of the directors of any Bank other
                        than HDFC Bank?
                        <strong>or</strong>
                        <br />
                        Are you a director/senior officer/relative of a director
                        or senior officer at HDFC Bank?
                        <form>
                            <div className="custom-inputs mt-4 mb-8 openSans-Reg text-black text-sm md:text-lg xl:text-xl">
                                <label className="inline-flex items-center">
                                    <input
                                        type="radio"
                                        name="standingInstructions"
                                        value="Yes"
                                        onChange={(e) =>
                                            this.handleOnChangeNutureOfReletionChecked(
                                                e
                                            )
                                        }
                                    />
                                    <span></span>
                                    <span className="ml-2">Yes</span>
                                </label>
                                <label className="inline-flex items-center ml-6">
                                    <input
                                        type="radio"
                                        name="standingInstructions"
                                        value="No"
                                        onChange={(e) =>
                                            this.handleOnChangeNutureOfReletionChecked(
                                                e
                                            )
                                        }
                                    />
                                    <span></span>
                                    <span className="ml-2">No</span>
                                </label>
                            </div>
                            <div
                                className={`flex flex-wrap w-full ${hiddenClassForNutureOfReleion}`}
                            >
                                <div className="relative w-full sm:w-7/12 lg:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                    <SelectForm
                                        title="Declaration on relationship with Directors of Banks"
                                        name="natureOfRelation"
                                        noneText="Select Relation"
                                        options={[
                                            { natureOfRelation: "Husband" },
                                            { natureOfRelation: "Wife" },
                                            { natureOfRelation: "Father" },
                                            { natureOfRelation: "Mother" },
                                            { natureOfRelation: "Son" },
                                            { natureOfRelation: "Son’s wife" },
                                            { natureOfRelation: "Daughter" },
                                            {
                                                natureOfRelation:
                                                    "Daughter’s husband",
                                            },
                                            { natureOfRelation: "Brother" },
                                            { natureOfRelation: "Sister" },
                                            {
                                                natureOfRelation:
                                                    "Members of a Hindu Undivided Family",
                                            },
                                        ]}
                                        handlerOnChange={(e) =>
                                            this.handleOnChangeNutureOfReletionInput(
                                                e
                                            )
                                        }
                                        errorText="Please select declaration on relationship with directors of banks"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="w-full flex flex-wrap my-8">
                        <button
                            onClick={() => this.props.onclickhandler()}
                            className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue high-amt-apply-submit mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4"
                        >
                            Agree
                        </button>
                        <button
                            onClick={() => this.props.history.push("offer")}
                            className="bg-transparent border-2 button-blue-border  blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default IAgreeTerms;
